import type { VoidFunctionComponent } from 'react';
import ActionMenuDropdown from './ActionMenuDropdown';

type ActionCellProps = {
  isPushOnly: boolean;
  onSetTokenToEdit: () => void;
  onDeleteToken: () => void;
};

const ActionCell: VoidFunctionComponent<ActionCellProps> = ({
  isPushOnly,
  onSetTokenToEdit,
  onDeleteToken,
}) => (
  <>
    { isPushOnly ? 'push-only' : 'full' }
    <ActionMenuDropdown
      onSetTokenToEdit={onSetTokenToEdit}
      onDeleteToken={onDeleteToken}
    />
  </>
);

export default ActionCell;
